import { Directive } from '@angular/core';
import { ValidatorFn, FormGroup, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appToDateValidation]'
})
export class ToDateValidationDirective {

  constructor() { }

}

export function toDateValidator(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      let dateTo = form.controls['toDate'].value;
      if (dateTo) {
        if (dateTo <= control.value) {
          return { 'toDateValidation': { value: control.value } }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}